import './testimonials.css';

const Testimonials = () => {
    return (
        <h1>Testimonials</h1>
    )
}

export default Testimonials;